export default "__VITE_ASSET__ddd506c6__"